import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { stateType, fetchFormById, isEditingResponse, setStateType } from '../reducer/form';
import FormViewExceededError from './response-errors/form-view-exceeded-error';
import SubmissionStartError from './response-errors/submission-start-error';
import FormContextProvider from '../../customise/contexts/form-context';
import ArchivedFormError from './response-errors/archived-form-error';
import EditExpiredError from './response-errors/edit-expired-error';
import FileStorageError from './response-errors/file-storage-error';
import UniqueLinkError from './response-errors/unique-link-error';
import GenericError from './response-errors/generic-form-error';
import FormLoader from './layout/form-loader/form-loader';
import WasError from './response-errors/was-error';
import ForbiddenError from './response-errors/403';
import NotFoundError from './response-errors/404';
import IntroPage from './intro-page/intro-page';
import MainForm from './layout/main_form';

const {
  LOADED,
  SUBMITTED,
  NOT_FOUND,
  WAS_ERROR,
  FORBIDDEN,
  NOT_VERIFIED,
  LINK_VISITED,
  EDIT_EXPIRED,
  ARCHIVED_FORM,
  QUOTA_EXCEEDED,
  FORM_VIEW_EXCEEDED,
  FILE_STORAGE_ERROR,
  PREMIUM_FIELDS_ERROR,
  SUBMISSION_START_ERROR,
} = stateType;

const genericErrors = [NOT_VERIFIED, QUOTA_EXCEEDED, PREMIUM_FIELDS_ERROR];

const Form = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const archivedForm = window.IS_ARCHIVED_FORM;
  const formViewExceeded = window.FORM_VIEW_EXCEEDED;
  const { loading, showIntroPage, form, responseState, reshowIntroPage } = useSelector((state) => state.form);

  const fetchForm = () => {
    if (!archivedForm && !formViewExceeded) {
      let savedResponseKey = null;
      let editResponseKey = null;

      if (location.pathname.includes('/saved/')) {
        savedResponseKey = location.pathname.split('/').pop();
      }

      if (location.pathname.includes('/edit/')) {
        dispatch(isEditingResponse(true));
        editResponseKey = window.location.pathname.split('/').pop();
      }
      dispatch(
        fetchFormById({ form_id: params.id, saved_response_key: savedResponseKey, edit_response_key: editResponseKey })
      );
    } else if (window.FORM_ID && archivedForm) {
      dispatch(setStateType(ARCHIVED_FORM));
    } else if (window.FORM_ID && formViewExceeded) {
      dispatch(setStateType(FORM_VIEW_EXCEEDED));
    } else {
      dispatch(setStateType(WAS_ERROR));
    }
  };

  useEffect(() => fetchForm(), []);

  return (
    <FormContextProvider
      additionalValues={{
        inForm: true,
      }}>
      {loading && <FormLoader />}
      {responseState !== LOADED && responseState !== SUBMITTED && (
        <section style={{ width: `${form.custom_form_width}%` }}>
          {responseState === WAS_ERROR && <WasError />}
          {responseState === NOT_FOUND && <NotFoundError />}
          {responseState === FORBIDDEN && <ForbiddenError />}
          {responseState === LINK_VISITED && <UniqueLinkError />}
          {responseState === EDIT_EXPIRED && <EditExpiredError />}
          {responseState === ARCHIVED_FORM && <ArchivedFormError />}
          {genericErrors.includes(responseState) && <GenericError />}
          {responseState === FILE_STORAGE_ERROR && <FileStorageError />}
          {responseState === FORM_VIEW_EXCEEDED && <FormViewExceededError />}
          {responseState === SUBMISSION_START_ERROR && <SubmissionStartError />}
          {/* Todo: add check for unsynced submissions made off line, also update reducer with the check */}
        </section>
      )}

      {(showIntroPage || reshowIntroPage) && <IntroPage />}
      {/* {!showIntroPage && form.design.page_background_type === 'pattern' && (
        <p className="pattern-library-attribution">
          Pattern from{' '}
          <a href="http://thepatternlibrary.com/" rel="noreferrer noopener" target="_blank">
            The Pattern Library
          </a>
        </p>
      )} */}
      {/* Todo: Add social media share icon for all screen sizes */}

      {responseState === LOADED && !showIntroPage && <MainForm />}
    </FormContextProvider>
  );
};

export default Form;
